import { defineMessages } from 'react-intl'

const messages = defineMessages({
  surveyLink: {
    id: 'SurveyController.surveyLink',
    description: 'URL a la encuesta',
    defaultMessage: 'https://www.orkestra.deusto.es/es/?option=com_rsform&view=rsform&formId=12'
  },
  logo: {
    id: 'SurveyController/logo',
    description: 'Logo que aparece en la encuesta',
    defaultMessage: '/img/logo-observatorio-competitividad-es.svg'
  },
  hello: {
    id: 'SurveyController.hello',
    description: 'Texto que encabeza el elemento',
    defaultMessage: 'Hola,'
  },
  thanks: {
    id: 'SurveyController.thanks',
    description: 'Texto de agradecimiento',
    defaultMessage: 'Muchas gracias por utilizar el Observatorio de Competividad de Orkestra.'
  },
  helpUs: {
    id: 'SurveyController.helpUs',
    description: 'Texto principal',
    defaultMessage: 'Ayúdanos a mejorar tu experiencia respondiendo a 4 preguntas en esta breve encuesta.'
  },
  thanksAgain: {
    id: 'SurveyController.thanksAgain',
    description: 'Agradecimiento final',
    defaultMessage: 'Gracias de nuevo. El equipo de Orkestra.'
  },
  yes: {
    id: 'SurveyController.yes',
    description: 'Sí',
    defaultMessage: 'Sí, encantado'
  },
  no: {
    id: 'SurveyController.no',
    description: 'No',
    defaultMessage: 'No, gracias'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Controllers/Survey/SurveyController/messages.js